import { isRetouchStaff } from '../../auth/roles';
import { createRoleRoute } from './createRoleRoute';

/**
 * Pathless layout under /admin for the retouch and Variants WORK surfaces:
 * AdminRoute already admitted a STAFF user; this admits RETOUCH_STAFF
 * (account_retoucher + admins) and gives everyone else — account_sales
 * included — Forbidden, deep links included. The Variants catalog is not
 * under this guard; it stays under AdminOnlyRoute.
 */
const RetouchStaffRoute = createRoleRoute('RetouchStaffRoute', isRetouchStaff, 'retouch_staff');

export default RetouchStaffRoute;
